import React from "react";
import { Link } from "react-router-dom";
import { ArthaLogo } from "./ArthaLogo";

const Footer = () => (
  <footer className="border-t border-border-subtle bg-surface-app mt-24" data-testid="marketing-footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
      <div className="col-span-2 md:col-span-2">
        <ArthaLogo size={28} />
        <p className="mt-4 text-sm text-ink-muted max-w-sm leading-relaxed">
          The business creation layer of the Mahakali Tribunal. Incorporate anywhere, stay compliant everywhere.
        </p>
        <p className="mt-6 text-xs text-ink-muted font-mono-accent">
          © {new Date().getFullYear()} Mahakali Tribunal · Artha
        </p>
      </div>
      <FooterCol title="Platform" items={[
        { to: "/countries", label: "Countries" },
        { to: "/pricing", label: "Pricing" },
        { to: "/partners", label: "Partner Network" },
        { to: "/resources", label: "Resources" },
      ]} />
      <FooterCol title="Ecosystem" items={[
        { to: "#", label: "Sri — Capital" },
        { to: "#", label: "Shrika — FinOps" },
        { to: "#", label: "Marianne — Legal" },
        { to: "#", label: "Clarke — Security" },
      ]} />
      <FooterCol title="Account" items={[
        { to: "/signup", label: "Sign up" },
        { to: "/login", label: "Sign in" },
        { to: "/app/dashboard", label: "Dashboard" },
      ]} />
    </div>
    <div className="border-t border-border-subtle py-5 px-6 md:px-12 lg:px-16 max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between gap-2 text-xs text-ink-muted">
      <div className="font-mono-accent uppercase tracking-[0.2em]">Built in the sun</div>
      <div>Terms · Privacy · Compliance</div>
    </div>
  </footer>
);

const FooterCol = ({ title, items }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.2em] text-ink-muted mb-4">{title}</div>
    <ul className="space-y-2.5">
      {items.map((it) => (
        <li key={it.label}>
          <Link to={it.to} className="text-sm text-ink-body hover:text-artha-amber transition-colors">
            {it.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
